
























import { computed, defineComponent } from "@vue/composition-api";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "WelcomeConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    value: { type: Boolean, default: false },
  },
  emits: ["becomeCreator", "continue"],
  setup() {
    const siteName = computed(() => config.siteName);
    return {
      siteName,
    };
  },
});
